import { memo } from 'react';
import styled from 'styled-components';

import getAvailabilty from '@utils/getAvailability';

import ProductMetaItem from './ProductMetaItem/ProductMetaItem';

const MetaList = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  list-style-type: none;
  margin: 0;
  margin-bottom: 2rem;
  padding: 0;

  @media ${(props) => props.theme.breakpoints.md} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export interface ProductMetaProps {
  figures?: string;
  figuresName?: string;
  isResponsive?: boolean;
  parts?: string;
  partsName?: string;
  reference?: string;
  referenceName?: string;
  releases?: [{ start: string; end?: string }];
}

const ProductMeta = ({
  figures,
  figuresName,
  parts,
  partsName,
  reference,
  referenceName,
  releases,
}: ProductMetaProps) => {
  const releaseStatus = getAvailabilty(releases || []);

  return (
    <MetaList>
      <ProductMetaItem
        title={referenceName || ''}
        type="reference"
        value={reference || ''}
      />
      {parts ? (
        <ProductMetaItem
          formatNumber={true}
          title={partsName || ''}
          type="parts"
          value={parts}
        />
      ) : (
        ''
      )}
      {figures ? (
        <ProductMetaItem
          formatNumber={true}
          title={figuresName || ''}
          type="figures"
          value={figures}
        />
      ) : (
        ''
      )}
      <ProductMetaItem
        title="Availability"
        type="release"
        value={releaseStatus.text || releaseStatus.status}
      />
    </MetaList>
  );
};

export default memo(ProductMeta);
